<template>
  <div class="main">
    <div class="top_back">
      <DivTop :active='3' />
      <div class="bj_box">
        <img src="@/assets/custmoer.png" alt="">
        <div class="bj_txt">
          <p>金飞鹰值得您的信赖</p>
          <span>让更多的企业因金飞鹰而受益</span>
        </div>
      </div>
    </div>
    <div class="swiper">
        <div class="w120 hei">
          <div  ref="container"
              @mouseenter="stopScrolling"
              @mouseleave="startScrollingOnLeave"
              @wheel="handleScroll">
              <div   :style="{ transform: `translateY(-${currentScrollTop}px)` }">
                <div  v-for="(item,index) in subtitles" :key="index" class="subtitle">
                  <img :src="item.imgs" alt="">
                </div>
              </div>
          </div>
        </div>
        <div class="swiper_txts">
          部分展示，排名不分先后
        </div>
    </div>
    <div class="guanli">
      <div class="box w120">
          <div>
            <span>助力开启智能管理</span>
            <span>关于北京金飞鹰智能科技更多资讯，请联系我们的销售和技术团队</span>
          </div>
      </div>
    </div>
    <Divfooter />
  </div>
</template>
<script>
export default {
  data(){
    return{
      subtitles:[
        {
          imgs:require('@/assets/swiper/one.png')
        },
        {
          imgs:require('@/assets/swiper/two.png')
        },
        {
          imgs:require('@/assets/swiper/three.png')
        },
        {
          imgs:require('@/assets/swiper/four.png')
        },
        {
          imgs:require('@/assets/swiper/five.png')
        },
        {
          imgs:require('@/assets/swiper/six.png')
        }
      ],
      scrollSpeed: 60, // 滚动速度，单位为毫秒
      scrollInterval: null, // 滚动间隔的引用
      containerHeight: 670, // 容器高度
      subtitleHeight:110, // 单个字幕的高度
      currentScrollTop: 0, // 当前滚动的位置
      isHovering: false // 标记鼠标是否悬停在容器上
    }
  },
  mounted(){
    this.containerHeight = this.$refs.container.offsetHeight;
    this.subtitleHeight = 120
    this.startScrolling();
  },
  methods:{
    startScrolling () {
      if (!this.isHovering) {
        this.scrollInterval = setInterval(() => {
          this.currentScrollTop += 1;
          // console.log(this.subtitleHeight)
          if (this.currentScrollTop >= this.subtitleHeight) {
            this.currentScrollTop = 0;
            this.subtitles.push(this.subtitles.shift());
          }
        }, this.scrollSpeed);
      }
    },
    stopScrolling () {
      clearInterval(this.scrollInterval);
      this.isHovering = true;
    },
    startScrollingOnLeave () {
      if (this.isHovering) {
        this.isHovering = false;
        this.startScrolling();
      }
    },
    handleScroll (event) {
      this.currentScrollTop += event.deltaY;
      if (this.currentScrollTop < 0) {
        this.currentScrollTop = 0;
      } else if (this.currentScrollTop > (this.subtitles.length * this.subtitleHeight - this.containerHeight)) {
        this.currentScrollTop = this.subtitles.length * this.subtitleHeight - this.containerHeight;
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.scrollInterval); // 在组件销毁前清除滚动间隔
  }
}
</script>
<style lang="less" scoped>
.main{
  width: 100%;
  .top_back{
    width: 100%;
    height: 52rem;
    background: #333B47;
    padding: 4.5rem 9.2rem 2rem 9.2rem;
    box-sizing: border-box;
    position: relative;
    img{
      width: 100%;
      height: 100%;
      
    }
    .bj_txt{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
    p{
      color: #F6F9FC;
      font-size: 4.6rem;
    }
    span{
      margin-top: 1.8rem;
      display: block;
      font-size: 1.6rem;
      color: #F6F9FC;
      text-align: center;
    }
  }
  .swiper{
    width: 100%;
    margin-top: -7rem;
    padding-bottom: 10rem;
    .hei{
      height: 76rem;
      overflow: hidden;
      >div{
        width: 100%;
        height: 11rem;
        margin-bottom: 2rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .swiper_txts{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3rem;
    color: #333B47;
    font-size: 1.6rem;
  }
  .guanli{
    width: 100%;
    height: 36.6rem;
    background: url(../../assets/guanli.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .box{
      height: 100%;
      >div{
        position: absolute;
        top: 50%;
        transform: translate(0,-50%); 
        right: 0;
        display: flex;
        flex-direction: column;
        color: #fff;
        span{
          text-align: right;
          &:nth-child(1){
            font-size: 2rem;
            color: #F6F9FC;
          }
          &:nth-child(2){
            display: block;
            margin-top: 1.7rem;
            font-size: 1.6rem ;
          }
        }
      }
    }
  }
}
</style>